import { Dialog, Transition } from "@headlessui/react";
import { Fragment, useEffect, useRef, useState } from "react";
import { Field, useFormikContext } from "formik";
import AddButton from "../buttons/button";
import CloseIcon from "../../assets/icons/close-icon";
import { QRCodeCanvas } from "qrcode.react";
import { imageUploadAction } from "../../redux/actions/general-action";
import { url } from "../../redux/config";
import { useDispatch } from "react-redux";
import successToast from "../helper-components/success-toast";
import errorToast from "../helper-components/error-toast";
import { socket } from "../../socket";

export default function BillingUploadPrescription({
  open,
  setOpen,
  isView = false,
}) {
  const dispatch = useDispatch();
  const { setFieldValue, values } = useFormikContext();
  const [loading, setLoading] = useState(false);
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [showImageViewer, setShowImageViewer] = useState(false);
  const fileInputRef = useRef(null);
  const MAX_FILES = 5;
  const MAX_TOTAL_SIZE = 5 * 1024 * 1024; // 5MB in bytes

  const handleFileChange = (event) => {
    const files = Array.from(event.target.files || []);

    if (files.length === 0) return;

    // Check file count limit
    const totalFiles = uploadedFiles.length + files.length;
    if (totalFiles > MAX_FILES) {
      errorToast(
        `Maximum ${MAX_FILES} files allowed. You can only select ${
          MAX_FILES - uploadedFiles.length
        } more files.`
      );
      event.target.value = "";
      return;
    }

    // Check total file size limit
    const newFilesSize = files.reduce((total, file) => total + file.size, 0);
    const currentFilesSize = uploadedFiles.reduce(
      (total, file) => total + (file.size || 0),
      0
    );
    const totalSize = currentFilesSize + newFilesSize;

    if (totalSize > MAX_TOTAL_SIZE) {
      errorToast(
        `Total file size cannot exceed 5MB. Current size: ${(
          currentFilesSize /
          (1024 * 1024)
        ).toFixed(2)}MB, Selected: ${(newFilesSize / (1024 * 1024)).toFixed(
          2
        )}MB`
      );
      event.target.value = "";
      return;
    }

    setLoading(true);

    // Upload files sequentially
    uploadFilesSequentially(files, 0, event);
  };

  const uploadFilesSequentially = (files, index, fileEvent) => {
    if (index >= files.length) {
      setLoading(false);
      if (fileEvent && fileEvent.target) {
        fileEvent.target.value = "";
      }
      return;
    }

    const file = files[index];
    console.log(`Uploading file ${index + 1}/${files.length}:`, file.name);

    dispatch(
      imageUploadAction(
        file,
        (data) => {
          const imageUrl = `${url}/image/${data}`;
          const fileWithSize = {
            url: imageUrl,
            size: file.size,
            name: file.name,
          };

          setUploadedFiles((prev) => {
            const updatedFiles = [...prev, fileWithSize];
            setFieldValue(
              "sot_prescription",
              updatedFiles.map((f) => f.url)
            );
            return updatedFiles;
          });

          successToast(`File ${index + 1} uploaded successfully`);

          // Upload next file after a short delay
          setTimeout(() => {
            uploadFilesSequentially(files, index + 1, fileEvent);
          }, 500);
        },
        (error) => {
          errorToast(`Failed to upload file ${index + 1}`);
          console.error("Upload error:", error);

          // Continue with next file even if current one failed
          setTimeout(() => {
            uploadFilesSequentially(files, index + 1, fileEvent);
          }, 500);
        }
      )
    );
  };

  const onSuccess = (data) => {
    setLoading(false);
    successToast("Uploaded Successfully");
    setFieldValue("sot_prescription", `${url}/image/${data}`);
    setOpen(false);
  };
  const onError = (data) => {
    setLoading(false);
  };

  const removeFile = (index) => {
    const updatedFiles = uploadedFiles.filter((_, i) => i !== index);
    setUploadedFiles(updatedFiles);
    setFieldValue(
      "sot_prescription",
      updatedFiles.map((f) => f.url)
    );
  };

  const openImageViewer = (index) => {
    setCurrentImageIndex(index);
    setShowImageViewer(true);
    // Close the transition sidebar when opening image viewer
    setOpen(false);
  };

  const closeImageViewer = () => {
    setShowImageViewer(false);
  };

  const goToPreviousImage = () => {
    console.log("=== GO TO PREVIOUS IMAGE ===");
    console.log("Current index:", currentImageIndex);
    console.log("Total files:", uploadedFiles.length);
    setCurrentImageIndex((prev) => {
      const newIndex = prev === 0 ? uploadedFiles.length - 1 : prev - 1;
      console.log("New index:", newIndex);
      return newIndex;
    });
  };

  const goToNextImage = () => {
    console.log("=== GO TO NEXT IMAGE ===");
    console.log("Current index:", currentImageIndex);
    console.log("Total files:", uploadedFiles.length);
    setCurrentImageIndex((prev) => {
      const newIndex = prev === uploadedFiles.length - 1 ? 0 : prev + 1;
      console.log("New index:", newIndex);
      return newIndex;
    });
  };

  const [localIP, setLocalIP] = useState("");

  useEffect(() => {
    const ip = localStorage.getItem("localIP");
    setLocalIP(ip);
  }, []);
  console.log(socket, "fgfgdgdfgdfgdfgdg");

  useEffect(() => {
    if (socket) {
      console.log("socket", socket);
      socket.on("prescriptionUploaded", (data) => {
        setFieldValue("sot_prescription", data?.imageurl);
        setOpen(false);
        successToast("Prescription Uploaded Successfully");
      });
    }
  }, [socket]);
  console.log(values?.sot_prescription, "fgfgdgdfgdfgdfgdg");

  return (
    <>
      <Transition.Root show={open}>
        <Dialog
          as="div"
          className="relative z-50"
          onClose={() => {
            setOpen(false);
            // setProductDetails({ item_id: "" });
          }}
        >
          <div className="fixed inset-0 overflow-hidden">
            <Transition.Child
              as="div"
              enter="ease-out duration-300"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <Dialog.Overlay className="absolute inset-0 bg-[#0000004D]" />
            </Transition.Child>

            <div className="fixed inset-0 flex justify-end">
              <Transition.Child
                as="div"
                enter="transform transition ease-in-out duration-300"
                enterFrom="translate-x-full"
                enterTo="translate-x-0"
                leave="transform transition ease-in-out duration-300"
                leaveFrom="translate-x-0"
                leaveTo="translate-x-full"
              >
                <Dialog.Panel className="h-full w-[400px] sm:w-[600px] bg-white overflow-y-auto rounded-tl-lg rounded-bl-lg shadow-xl">
                  {/* Header */}
                  <div
                    className="h-[61px] bg-[var(--slide-panel-head-bg)] px-3 flex items-center justify-between border-b"
                    style={{ borderColor: "var(--slide-panel-border)" }}
                  >
                    <div
                      style={{
                        maxHeight: "32px",
                        color: "var(--slide-panel-h-fg)",
                        fontSize: "var(--slide-panel-h-fs)",
                        fontWeight: "var(--slide-panel-h-fw)",
                      }}
                      className="min-w-[75%] "
                    >
                      Upload Prescription
                    </div>
                    <AddButton
                      onclkFn={() => {
                        setOpen(false);
                        // setProductDetails({ item_id: "" });
                      }}
                      icon={
                        <CloseIcon
                          width="12px"
                          height="12px"
                          fill="var(--close-button-fg)"
                        />
                      }
                      text={
                        <span>
                          Close <span className="opacity-50">(X)</span>{" "}
                        </span>
                      }
                      className="flex h-[32px]  items-center gap-2 bg-[var(--close-button-bg)] border-radius px-3 text-[var(--close-button-fg)]"
                    />
                  </div>

                  {/* Product Detail Panel */}
                  <div
                    style={{
                      height: `calc(100% - 61px)`,
                      minHeight: `calc(100% - 61px)`,
                    }}
                    className="px-4 relative flex flex-col gap-5 items-center justify-center"
                  >
                    {isView ? (
                      <div className="w-full h-full overflow-y-auto p-4">
                        <div className="grid grid-cols-2 gap-4">
                          {uploadedFiles.map((file, index) => (
                            <div key={index} className="relative group">
                              <img
                                alt={`Prescription ${index + 1}`}
                                className="w-full h-auto rounded-md border cursor-pointer hover:opacity-90 transition-opacity"
                                src={file.url}
                                onClick={() => openImageViewer(index)}
                              />
                              <div className="text-xs text-gray-500 mt-1 truncate">
                                <div className="font-medium">{file.name}</div>
                                <div className="text-gray-400">
                                  {(file.size / (1024 * 1024)).toFixed(2)}MB
                                </div>
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>
                    ) : (
                      <>
                        <div
                          className="w-[17rem] h-[20rem] rounded-md p-2"
                          style={{
                            boxShadow: "var(--qr-code-box-shadow-bg)",
                          }}
                        >
                          <div className="h-[15.5rem] bg-[var(--qr-code-bg)] border-radius flex justify-center items-center">
                            <div className="h-[12rem] w-[80%]">
                              <QRCodeCanvas
                                value={`http://${localIP}:8000/api/order/upload`}
                                size={200}
                                fgColor="black"
                                bgColor="#ffffff"
                              />
                            </div>
                          </div>
                          <div className="w-full flex justify-center mt-[1rem]">
                            <p className="text-[var(--qr-code-fg)] w-[70%]  text-center text-[length:var(--qr-code-fs)] font-[var(--qr-code-fw)]">
                              Scan this QR to upload prescription
                            </p>
                          </div>
                        </div>

                        {/* Uploaded Files Display */}
                        {uploadedFiles.length > 0 && (
                          <div className="w-full max-h-[200px] overflow-y-auto">
                            <div className="flex justify-between items-center mb-2">
                              <h4 className="text-sm font-medium text-gray-700">
                                Uploaded Files ({uploadedFiles.length}/
                                {MAX_FILES}
                                ):
                              </h4>
                              <div className="text-xs text-gray-600 bg-gray-100 px-2 py-1 rounded">
                                Total Size:{" "}
                                {(
                                  uploadedFiles.reduce(
                                    (total, file) => total + (file.size || 0),
                                    0
                                  ) /
                                  (1024 * 1024)
                                ).toFixed(2)}
                                MB
                              </div>
                            </div>
                            <div className="grid grid-cols-3 gap-2">
                              {uploadedFiles.map((file, index) => (
                                <div key={index} className="relative group">
                                  <img
                                    src={file.url}
                                    alt={`Upload ${index + 1}`}
                                    className="w-full h-24 object-cover rounded border"
                                  />
                                  <button
                                    type="button"
                                    onClick={() => removeFile(index)}
                                    className="absolute top-2 right-2  bg-[var(--unselect-presc-close-bg)] hover:bg-gray-800 text-[var(--unselect-presc-close)] rounded-full w-7 h-7 flex items-center justify-center text-lg font-bold shadow-lg border-2 border-white transition-all duration-200"
                                    title="Remove file"
                                  >
                                    ×
                                  </button>
                                  <div className="text-xs text-gray-500 mt-1 truncate">
                                    <div className="font-medium">
                                      {file.name}
                                    </div>
                                    <div className="text-gray-400">
                                      {(file.size / (1024 * 1024)).toFixed(2)}MB
                                    </div>
                                  </div>
                                </div>
                              ))}
                            </div>
                          </div>
                        )}

                        <AddButton
                          loading={loading}
                          prefixIcon={false}
                          text={`Upload From System (U) - ${
                            uploadedFiles.length
                          }/${MAX_FILES} - ${(
                            uploadedFiles.reduce(
                              (total, file) => total + (file.size || 0),
                              0
                            ) /
                            (1024 * 1024)
                          ).toFixed(2)}MB`}
                          className="flex items-center px-[30px] h-[44px] whitespace-nowrap rounded-md gap-[8px]
    bg-[var(--primary-button-bg-color)] cursor-pointer
    text-[var(--primary-button-fg-color)]
    border border-[var(--primary-button-bg-color)]
    hover:bg-[var(--primary-button-hover-color)]
    text-[length:var(--primary-button-font-size)] 
    font-[var(--primary-button-font-weight)]"
                          type="button"
                          onclkFn={() => fileInputRef.current?.click()} // 👈 Trigger click
                        />

                        <Field name={"sot_prescription"}>
                          {({ field }) => (
                            <input
                              ref={fileInputRef}
                              disabled={false}
                              id={"sot_prescription"}
                              type="file"
                              multiple
                              accept=".png, .jpg, .jpeg"
                              onChange={(event) => {
                                handleFileChange(event);
                                field.onChange(event);
                              }}
                              onBlur={field.onBlur}
                              style={{ display: "none" }}
                            />
                          )}
                        </Field>
                      </>
                    )}
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>

        {/* Full-screen Image Viewer */}
        {showImageViewer && uploadedFiles.length > 0 && (
          <div className="fixed inset-0 z-50 bg-black bg-opacity-90 flex items-center justify-center">
            {/* Close Button */}
            <button
              onClick={closeImageViewer}
              className="absolute top-4 right-4 z-10 flex h-[32px] items-center gap-2 bg-[var(--close-button-bg)] border-radius px-3 text-[var(--close-button-fg)]"
            >
              <CloseIcon
                width="12px"
                height="12px"
                fill="var(--close-button-fg)"
              />
              <span>
                Close <span className="opacity-50">(X)</span>
              </span>
            </button>

            {/* Navigation Arrows */}
            {uploadedFiles.length > 1 && (
              <>
                <button
                  onClick={(e) => {
                    console.log("=== PREVIOUS BUTTON CLICKED ===");
                    e.preventDefault();
                    e.stopPropagation();
                    goToPreviousImage();
                  }}
                  className="absolute left-4 top-1/2 transform -translate-y-1/2 bg-black bg-opacity-50 hover:bg-opacity-75 text-white p-3 rounded-full transition-all duration-200 z-10"
                  title="Previous image"
                >
                  <svg
                    className="w-6 h-6"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M15 19l-7-7 7-7"
                    />
                  </svg>
                </button>
                <button
                  onClick={(e) => {
                    console.log("=== NEXT BUTTON CLICKED ===");
                    e.preventDefault();
                    e.stopPropagation();
                    goToNextImage();
                  }}
                  className="absolute right-4 top-1/2 transform -translate-y-1/2 bg-black bg-opacity-50 hover:bg-opacity-75 text-white p-3 rounded-full transition-all duration-200 z-10"
                  title="Next image"
                >
                  <svg
                    className="w-6 h-6"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M9 5l7 7-7 7"
                    />
                  </svg>
                </button>
              </>
            )}

            {/* Image Display */}
            <div className="relative max-w-[90vw] max-h-[90vh] flex items-center justify-center">
              <img
                src={uploadedFiles[currentImageIndex]?.url}
                alt={`Prescription ${currentImageIndex + 1}`}
                className="max-w-full max-h-full object-contain rounded-lg"
              />
            </div>

            {/* Image Counter */}
            {uploadedFiles.length > 1 && (
              <div className="absolute bottom-4 left-1/2 transform -translate-x-1/2 bg-black bg-opacity-50 text-white px-4 py-2 rounded-full text-sm">
                {currentImageIndex + 1} / {uploadedFiles.length}
              </div>
            )}

            {/* File Info */}
            <div className="absolute bottom-4 right-4 bg-black bg-opacity-50 text-white px-4 py-2 rounded-lg text-sm">
              <div className="font-medium">
                {uploadedFiles[currentImageIndex]?.name}
              </div>
              <div className="text-gray-300">
                {(
                  uploadedFiles[currentImageIndex]?.size /
                  (1024 * 1024)
                ).toFixed(2)}
                MB
              </div>
            </div>
          </div>
        )}
      </Transition.Root>

      {/* Full-screen Image Viewer - Outside Transition.Root */}
      {showImageViewer && uploadedFiles.length > 0 && (
        <div className="fixed inset-0 z-50 bg-black bg-opacity-90 flex items-center justify-center">
          {/* Close Button */}
          <button
            onClick={closeImageViewer}
            className="absolute top-4 right-4 z-10 flex h-[32px] items-center gap-2 bg-[var(--close-button-bg)] border-radius px-3 text-[var(--close-button-fg)]"
          >
            <CloseIcon
              width="12px"
              height="12px"
              fill="var(--close-button-fg)"
            />
            <span>
              Close <span className="opacity-50">(X)</span>
            </span>
          </button>

          {/* Navigation Arrows */}
          {uploadedFiles.length > 1 && (
            <>
              <button
                onClick={(e) => {
                  console.log("=== PREVIOUS BUTTON CLICKED (OUTSIDE) ===");
                  e.preventDefault();
                  e.stopPropagation();
                  goToPreviousImage();
                }}
                className="absolute left-4 top-1/2 transform -translate-y-1/2 bg-black bg-opacity-50 hover:bg-opacity-75 text-white p-3 rounded-full transition-all duration-200 z-10"
                title="Previous image"
              >
                <svg
                  className="w-6 h-6"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M15 19l-7-7 7-7"
                  />
                </svg>
              </button>
              <button
                onClick={(e) => {
                  console.log("=== NEXT BUTTON CLICKED (OUTSIDE) ===");
                  e.preventDefault();
                  e.stopPropagation();
                  goToNextImage();
                }}
                className="absolute right-4 top-1/2 transform -translate-y-1/2 bg-black bg-opacity-50 hover:bg-opacity-75 text-white p-3 rounded-full transition-all duration-200 z-10"
                title="Next image"
              >
                <svg
                  className="w-6 h-6"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M9 5l7 7-7 7"
                  />
                </svg>
              </button>
            </>
          )}

          {/* Image Display */}
          <div className="relative w-full flex items-center justify-center">
            <img
              src={uploadedFiles[currentImageIndex]?.url}
              alt={`Prescription ${currentImageIndex + 1}`}
              className="w-full h-auto object-contain rounded-lg"
              style={{ maxHeight: "90vh" }}
            />
          </div>

          {/* Image Counter */}
          {uploadedFiles.length > 1 && (
            <div className="absolute bottom-4 left-1/2 transform -translate-x-1/2 bg-black bg-opacity-50 text-white px-4 py-2 rounded-full text-sm">
              {currentImageIndex + 1} / {uploadedFiles.length}
            </div>
          )}

          {/* File Info */}
          <div className="absolute bottom-4 right-4 bg-black bg-opacity-50 text-white px-4 py-2 rounded-lg text-sm">
            <div className="font-medium">
              {uploadedFiles[currentImageIndex]?.name}
            </div>
            <div className="text-gray-300">
              {(uploadedFiles[currentImageIndex]?.size / (1024 * 1024)).toFixed(
                2
              )}
              MB
            </div>
          </div>
        </div>
      )}
    </>
  );
}
